import React from 'react'

function Amenities() {
  return (
    <div>  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58268 17.9998C13.9549 17.9998 17.4993 14.4554 17.4993 10.0832C17.4993 5.71092 13.9549 2.1665 9.58268 2.1665C5.21043 2.1665 1.66602 5.71092 1.66602 10.0832C1.66602 14.4554 5.21043 17.9998 9.58268 17.9998Z"
      stroke="#202020"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3327 18.8332L16.666 17.1665"
      stroke="#202020"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Amenities